<template>
  <div v-if="masterCampaign">
    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-4/5 w-full">
          <h2>Master Campaign</h2>
          <h5 class="my-5" v-if="!isEditable">
            <b
              >Note: Can no longer be edited as campaign has status
              {{ masterStatusObject(masterCampaign.masterStatus).text }}.</b
            >
          </h5>
          <p class="mt-2 mb-2">
            Here you can specify which venues to include in the campaign and compose a base email and/or sms
            template. <br />
            When the campaign is ready, distribute it to the chosen venues, which can then adjust the campaign
            as needed.
            <br />
          </p>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input label="" v-model="masterCampaign.title" class="w-full" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Venues</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <venue-selector v-model="masterCampaign.venues" :multiple="true" />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Fillout deadline</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span style="font-size: 11px">Venue managers must have their campaign approved by this date</span>
          <DatePicker
            :attributes="calendarAttributes"
            is-expanded
            v-model="masterCampaign.approvedByDate"
          ></DatePicker>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Send date</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span style="font-size: 11px">The date that the campaign will be sent out (not automatically)</span>
          <DatePicker
            :attributes="calendarAttributes"
            is-expanded
            v-model="masterCampaign.sendByDate"
          ></DatePicker>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Has Email</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-checkbox v-model="masterCampaign.hasEmail" class="w-full" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Has Sms</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-checkbox v-model="masterCampaign.hasSms" class="w-full" />
        </div>
      </div>

      <!-- Save & Remove Button -->
      <vs-row vs-justify="flex-end" class="flex flex-wrap items-center" style="margin-top: 32px">
        <vs-button
          id="save-button"
          v-if="isEditable && $AuthService.hasPermissionForActiveVenue('vp.crm.campaigns.edit')"
          @click="$emit('onSave')"
          class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import flatPickr from "vue-flatpickr-component";
import { DatePicker } from "v-calendar";
import campaignMixin from "@/views/mixins/campaignMixin";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  props: ["masterCampaign", "isEditable"],
  mixins: [campaignMixin],
  components: {
    flatPickr,
    DatePicker,
    VenueSelector,
  },
  data() {
    console.log("Master campaign", this.masterCampaign.venues);
    return {
      calendarAttributes: [
        {
          key: "today",
          highlight: "gray",
          dates: new Date(),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      venues: "venues/venues",
    }),
  },
};
</script>

<style lang="scss">
</style>